/**
 * localStorage helpers used by the zustand stores that need to survive reload.
 *
 * Keep the API surface tiny — the goal is a consistent pattern across stores,
 * not a persistence framework. Failures are swallowed: private-mode, quota,
 * or missing `localStorage` (SSR-shaped runtimes) all fall back to defaults.
 */

export function loadJson<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return fallback;
    const parsed = JSON.parse(raw) as Partial<T>;
    return { ...fallback, ...parsed };
  } catch {
    return fallback;
  }
}

export function saveJson<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota / private mode — drop */
  }
}
